import { useEffect } from "react";
import { UI_URL } from "../config/api";
import { APP_URL } from "../config/api";
import axios from "axios";

const EndMeetingPage = () => {
  useEffect(() => {
    let slug = localStorage.getItem("trSlug");
    let id = localStorage.getItem("trTopicId");
    let data = {};
    if (slug) {
      data = { slug: slug };
    } 
    if (id) {
      data = { id: id };
    }
    axios
      .request({
        method: "post",
        url: `${APP_URL}/end-meeting`,
        data: data,
      })
      .then((res) => {
        localStorage.removeItem("start");
        localStorage.setItem("meetingRedirect", true);
        localStorage.removeItem("trSlug");
        localStorage.removeItem("trTopicId");
        window.top.location.href = UI_URL + "/";
      })
      .catch((error) => {});

    // window.close();

    //window.close();
  }, []);

  return <div></div>;
};

export default EndMeetingPage;
